module.exports = __webpack_public_path__ + "img/select-found-exhibit.ddd4f0e6.png";